import {
  faArrowLeft,
  faSave,
  faTimes
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FalconComponentCard from 'components/common/FalconComponentCard';
import Flex from 'components/common/Flex';
import FolderGroupSelect from 'components/common/FolderGroupSelect'; // Importar o novo componente
import IconButton from 'components/common/IconButton';
import Editor from 'components/editor/Editor';
import KbFolderRegistrationModal from 'components/modals/KbFolderRegistrationModal';
import TagSearch from 'components/tags/TagSearch';
import useNotification from 'hooks/useNotification';
import { useEffect, useState } from 'react';
import {
  Badge,
  Button,
  Card,
  Col,
  Container,
  Dropdown,
  Form,
  Row
} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import KbArticlesService from 'services/KbArticles.service';
import KbGroupsService from 'services/KbGroups.service';

const ArticleRegistration = () => {
  const { showSuccessNotification, showErrorNotification } = useNotification();
  const navigate = useNavigate();
  const [articleData, setArticleData] = useState({
    title: '',
    content: '',
    tags: [],
    kbFolder: { id: '' }
  });

  const [validation, setValidation] = useState({
    title: true,
    content: true,
    folder: true // Adicionar validação para pasta
  });

  const [showFolderModal, setShowFolderModal] = useState(false);
  const [folderToEdit, setFolderToEdit] = useState(null);
  const [isEditingFolder, setIsEditingFolder] = useState(false);
  const [groups, setGroups] = useState([]); // Renomeado de folders para groups

  useEffect(() => {
    getGroups();
  }, []);

  const getGroups = async () => {
    try {
      const response = await KbGroupsService.listWithFolders();
      if (!response.userMessage) {
        setGroups(response);
      }
    } catch (error) {
      console.error('Erro ao buscar grupos:', error);
    }
  };

  // Função para atualizar o conteúdo e validação
  const handleSetBody = (isValid, field, value) => {
    setArticleData({
      ...articleData,
      [field]: value
    });

    setValidation({
      ...validation,
      [field]: isValid
    });
  };

  const handleInputChange = (field, value) => {
    setArticleData({
      ...articleData,
      [field]: value
    });

    // Atualizar validação se necessário
    if (field === 'title') {
      setValidation({
        ...validation,
        title: value.trim() !== ''
      });
    }
  };

  // Função específica para lidar com mudança de pasta
  const handleFolderChange = folderId => {
    setArticleData({
      ...articleData,
      kbFolder: { id: parseInt(folderId) }
    });

    setValidation({
      ...validation,
      folder: folderId !== ''
    });
  };

  // Funções para gerenciar tags
  const handleAddTag = tag => {
    if (tag.trim() !== '' && !articleData.tags.includes(tag.trim())) {
      setArticleData({
        ...articleData,
        tags: [...articleData.tags, tag.trim()]
      });
    }
  };

  const handleRemoveTag = tag => {
    setArticleData({
      ...articleData,
      tags: articleData.tags.filter(t => t !== tag)
    });
  };

  // Funções para salvar
  const handleSave = async e => {
    e.preventDefault();
    e.stopPropagation();
    console.log('Salvando artigo:', articleData);

    const response = await KbArticlesService.create(articleData);
    if (response.userMessage) {
      showErrorNotification(response.userMessage);
      return;
    }

    showSuccessNotification('Artigo salvo com sucesso');
    setTimeout(() => {
      navigate(`/documents/articles/${response.id}`);
    }, 1000);
  };

  // Funções para publicar
  const handlePublish = async e => {
    e.preventDefault();
    e.stopPropagation();

    const response = await KbArticlesService.createAndPublish(articleData);
    if (response.userMessage) {
      showErrorNotification(response.userMessage);
      return;
    }

    showSuccessNotification('Artigo publicado com sucesso!');
    setTimeout(() => {
      navigate(`/documents/articles/${response.id}`);
    }, 2000);
  };

  const handleCloseFolderModal = () => {
    setShowFolderModal(false);
    setFolderToEdit(null);
    setIsEditingFolder(false);
    // Recarregar grupos após fechar modal
    getGroups();
  };

  return (
    <>
      <KbFolderRegistrationModal
        showModal={showFolderModal}
        handleClose={handleCloseFolderModal}
        isSuccess={() => {}}
        groups={groups}
        agents={[]}
        customers={[]}
        isEditing={isEditingFolder}
        folderToEdit={folderToEdit}
      />

      {/* SINGLE CARD WITH ALL CONTENT */}
      <FalconComponentCard style={{ minHeight: '87vh' }}>
        <Container>
          <Flex alignItems={'center'}>
            <IconButton
              icon={faArrowLeft}
              variant="falcon-default"
              size="sm"
              className="ms-3"
              onClick={() => navigate(-1)}
            />
            <FalconComponentCard.Header
              className={'ps-2'}
              title={'Criar artigo'}
            />
          </Flex>

          <FalconComponentCard.Body>
            <Form>
              <Form.Group className="mb-3" controlId="articleTitle">
                <Form.Label>
                  Título <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Título"
                  value={articleData.title}
                  onChange={e => handleInputChange('title', e.target.value)}
                  isInvalid={!validation.title}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  O título é obrigatório.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group controlId="articleContent" className="mb-4">
                <Form.Label>
                  Conteúdo <span className="text-danger">*</span>
                </Form.Label>
                <div style={{ height: '400px' }}>
                  <Editor
                    data={articleData.content}
                    value={value => handleSetBody(true, 'content', value)}
                  />
                </div>
                <Form.Control.Feedback>Muito bom!</Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  Insira conteúdo para o artigo.
                </Form.Control.Feedback>
              </Form.Group>

              {/* PROPRIEDADES DO ARTIGO abaixo do editor */}
              <Row>
                <Col lg={12}>
                  <div className="mb-2 align-items-center">
                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Flex justifyContent="between" alignItems="center">
                            <Form.Label>
                              Pasta <span className="text-danger">*</span>
                            </Form.Label>
                            <Button
                              variant="link"
                              onClick={() => setShowFolderModal(true)}
                              className="p-0 text-decoration-none"
                            >
                              + Criar novo
                            </Button>
                          </Flex>

                          {/* Usando o novo componente personalizado */}
                          <FolderGroupSelect
                            groups={groups}
                            value={articleData.kbFolder.id}
                            onChange={handleFolderChange}
                            placeholder="Selecionar pasta"
                            isInvalid={!validation.folder}
                            required={true}
                          />

                          <Form.Control.Feedback type="invalid">
                            Selecione uma pasta.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label className="mb-2">Tags</Form.Label>
                          <TagSearch onAddTag={handleAddTag} />
                          <div className="mt-1">
                            {articleData.tags.map((tag, index) => (
                              <Badge
                                key={index}
                                bg="light"
                                text="dark"
                                className="me-1 p-2"
                                style={{ cursor: 'pointer' }}
                                onClick={() => handleRemoveTag(tag)}
                              >
                                {tag} &times;
                              </Badge>
                            ))}
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>

              <Card.Footer className="position-relative bottom-0">
                <Flex justifyContent={'end'}>
                  <Button
                    variant="falcon-default"
                    className="me-2"
                    onClick={() => navigate(-1)}
                  >
                    <FontAwesomeIcon icon={faTimes} className="me-1" /> Cancelar
                  </Button>
                  <>
                    <Button
                      variant="primary"
                      style={{ borderRadius: '20px 0px 0px 20px' }}
                      onClick={handleSave}
                    >
                      <FontAwesomeIcon icon={faSave} className="me-1" /> Salvar
                    </Button>

                    <Dropdown>
                      <Dropdown.Toggle
                        className="ps-1"
                        style={{
                          borderRadius: '0px 20px 20px 0px',
                          height: '100%'
                        }}
                      />
                      <Dropdown.Menu className="flex-wrap">
                        <Dropdown.Item
                          as={Button}
                          type="submit"
                          variant="link"
                          onClick={handlePublish}
                          className="fs-10"
                        >
                          Salvar e Publicar
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </>
                </Flex>
              </Card.Footer>
            </Form>
          </FalconComponentCard.Body>
        </Container>
      </FalconComponentCard>
    </>
  );
};

export default ArticleRegistration;
